import { defineComponent as _defineComponent } from 'vue'
import { useProtestEventsStore } from "@/stores/protest-events";
import { computed, ref } from "vue";
import NationalAnalysisDataAlert from "./NationalAnalysisDataAlert.vue";

import { formatter } from "@/plugins/echarts";


export default /*#__PURE__*/_defineComponent({
  __name: 'NationalAnalysisEventsChart',
  setup(__props) {

let isLoading = ref<boolean>(true);
setTimeout(() => (isLoading.value = false), 0.1);

const protestEventsStore = useProtestEventsStore();

const observationUnit = ref<string>("Anzahl der Protestevents");
const observationUnits = ref<string[]>([
  "Anzahl der Protestevents",
  "Absolute Anzahl an Teilnehmer:innen",
]);

const chartOptions = computed(() => ({
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    formatter: formatter,
  },
  dataZoom: [
    {
      id: "dataZoomX",
      type: "slider",
      xAxisIndex: [0],
      filterMode: "filter",
      minValueSpan: 3600 * 24 * 1000 * 365,
      backgroundColor: "rgba(53, 65, 90,0)",
      dataBackgroundColor: "rgba(53,65,90,0.3)",
      fillerColor: "rgba(169,188,208,0.1)",
      handleSize: "100%",
      textStyle: {
        color: "#333333",
      },
      showDetail: false,
    },
  ],
  grid: {
    top: "3%",
    left: "3%",
    right: "4%",
    bottom: "12%",
    containLabel: true,
  },
  xAxis: {
    type: "time",
  },
  yAxis: {
    type: "value",
    minInterval: 1,
  },
  series: protestEventsStore.protestEventsOverTime(
    [],
    [],
    [],
    observationUnit.value,
    true
  ),
}));

return { __sfc: true,isLoading, protestEventsStore, observationUnit, observationUnits, chartOptions, NationalAnalysisDataAlert }
}

})